var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudflareMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 29 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter-+-Site",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DNS",
    transform: "translate(-125.000000, -234.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(125.000000, 234.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "7 13 26 13 26 7.46280118 22.3904016 5.28353801 21.7676986 5 7.00023623 5.10620239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6401484,12.3014848 C19.8158782,11.6947487 19.7489223,11.1386331 19.4559611,10.7260999 C19.1881377,10.3469195 18.7363619,10.1276429 18.1920225,10.1025692 L7.89068846,9.967739 C7.82701853,9.96822778 7.76732474,9.93662252 7.73163895,9.88352924 C7.69827849,9.83290877 7.68982091,9.76525711 7.70650114,9.69807853 C7.7398616,9.59707413 7.84041284,9.52114342 7.94918673,9.51262782 L18.3426145,9.37779759 C19.5727227,9.31866152 20.9116048,8.31618691 21.3802958,7.08568361 L21.9746758,5.52449143 C22,5.45707631 22.0080363,5.3896612 21.9911211,5.32224608 C21.3222674,2.27484625 18.6191304,0 15.3890391,0 C12.410091,0 9.8826838,1.93800721 8.97889726,4.6256232 C8.39320975,4.18754321 7.6482378,3.95147203 6.8450025,4.0271662 C5.41426166,4.17051203 4.26778952,5.32461152 4.12542023,6.76540267 C4.09205977,7.13606754 4.11696265,7.49868991 4.20059873,7.83552895 C1.86583642,7.90294407 0,9.82392008 0,12.1914917 C0,12.4043815 0.0164452971,12.6125405 0.0418180411,12.8230649 C0.0582633382,12.9240693 0.142134353,13 0.242685598,13 L19.2553285,13 C19.3641024,13 19.466768,12.9243058 19.4980141,12.8145493 L19.6403833,12.3005386 L19.6401484,12.3014848 Z",
    id: "Path",
    fill: "#F38020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9514863,6 L22.6464896,6.00811202 C22.5746515,6.00811202 22.5118877,6.05633349 22.485169,6.12077901 L22.0566612,7.46151618 C21.8681178,8.03949783 21.9399558,8.56925801 22.2542789,8.96224046 C22.5416312,9.32345083 23.0263492,9.53233543 23.6103801,9.55622083 L25.9626359,9.68466119 C26.0309484,9.68419558 26.0949949,9.714303 26.1332828,9.76488009 C26.1690758,9.81310156 26.1781501,9.88520843 26.1602536,9.94154193 C26.1244606,10.0377595 26.0165774,10.1100917 25.8998721,10.1182038 L23.4488074,10.2466441 C22.1199291,10.3029776 20.692494,11.257943 20.1896275,12.4301304 L20.0101584,12.8395622 C19.9743653,12.9197811 20.0371291,13 20.1361901,13 L28.5576287,13 C28.6564376,13 28.7461721,12.9436665 28.7731429,12.8557863 C28.9168191,12.3902463 29,11.9003702 29,11.3949461 C29,8.42504426 26.2885539,6.00112667 22.9575358,6.00112667",
    id: "Path",
    fill: "#FAAE40"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudflareMobile);
export default __webpack_public_path__ + "static/media/cloudflare_mobile.669f56c2a0fdb7de6db92882e039ae9e.svg";
export { ForwardRef as ReactComponent };